import { useEffect } from 'react';
import useFetch from 'hooks/fetch';
import { useAppDispatch } from 'store/hooks';
import { getWatchListsOfStock } from '../actions';
const useStockWatchListInfo = (assetId) => {
    const dispatch = useAppDispatch();
    const [fetch] = useFetch();
    useEffect(() => {
        if (assetId) {
            const getStocksWatchLists = async () => {
                try {
                    const response = await fetch(getWatchListsOfStock(assetId));
                    const action = {
                        assetId,
                        type: 'GET_WATCHLIST_OF_STOCK_SUCCESS',
                        payload: {
                            watchlistIds: response.watchlistIds,
                        },
                    };
                    dispatch(action);
                }
                catch {
                    //
                }
            };
            getStocksWatchLists();
        }
    }, [assetId]);
};
export default useStockWatchListInfo;
